'use client'

import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import Demo from './Demo'
import { FaPlay } from 'react-icons/fa';
import langIso from '../Data/lang-iso.json'
import { IoLanguage } from "react-icons/io5";

export default function Hero() {
  const [showDemo, setShowDemo] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleToggleDemo = () => {
    setShowDemo(!showDemo);
  };

  const getNativeLanguageName = (code) => {
    const language = langIso.find(lang => lang.code === code);
    return language ? language.nativeName : code;
  };

  useEffect(() => {
    const handleToggleDemoEvent = () => {
      setShowDemo((prev) => !prev);
    };

    window.addEventListener('toggleDemo', handleToggleDemoEvent);

    return () => {
      window.removeEventListener('toggleDemo', handleToggleDemoEvent);
    };
  }, []);

  return (
    <div id="hero" className="relative isolate overflow-hidden w-full bg-gradient-to-br from-violet-50 to-indigo-100 min-h-screen flex items-center">
      <div className="absolute inset-x-0 top-[-10rem] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[-20rem]">
        <svg
          className="relative left-[calc(50%-11rem)] -z-10 h-[21.1875rem] max-w-none -translate-x-1/2 rotate-[30deg] sm:left-[calc(50%-30rem)] sm:h-[42.375rem]"
          viewBox="0 0 1155 678"
        >
          <path
            fill="url(#45de2b6b-92d5-4d68-a6a0-9b9b2abad533)"
            fillOpacity=".3"
            d="M317.219 518.975L203.852 678 0 438.341l317.219 80.634 204.172-286.402c1.307 132.337 45.083 346.658 209.733 145.248C936.936 126.058 882.053-94.234 1031.02 41.331c119.18 108.451 130.68 295.337 121.53 375.223L855 299l21.173 362.054-558.954-142.079z"
          />
          <defs>
            <linearGradient
              id="45de2b6b-92d5-4d68-a6a0-9b9b2abad533"
              x1="1155.49"
              x2="-78.208"
              y1=".177"
              y2="474.645"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#8B5CF6" />
              <stop offset={1} stopColor="#6366F1" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="mx-auto max-w-7xl px-6 lg:px-8 py-24 sm:py-32">
        <div className="text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="flex justify-center">
              <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl lg:text-7xl mt-20">
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-indigo-600">
                  Cross-Border
                </span>{' '}
                Regulatory Intelligence
              </h1>
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <p className="mt-6 text-xl leading-8 text-gray-600 max-w-2xl mx-auto">
              Empower your global business with AI-driven insights and strategic solutions
            </p>
          </motion.div>
      


{!showDemo && (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5, delay: 0.4 }}
  >
    <button
      onClick={handleToggleDemo}
      className="mt-8 px-6 py-3 bg-indigo-600 text-white font-semibold rounded-md shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
    >
      <FaPlay className="inline-block mr-2" />
      Try Demo
    </button>
    <button
      onClick={handleToggleDemo}
      className="mt-8 ml-4 px-6 py-3 border border-indigo-600 text-indigo-600 font-semibold rounded-md shadow-md hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
    >
      <IoLanguage className="inline-block mr-2" />
      Try in Your Language
    </button>
    <p className="mt-4 text-sm text-gray-500 text-center">
      No sign-in required <span className='text-indigo-600'>*</span>
    </p>
  </motion.div>
)}



</div>
{showDemo && (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5, delay: 0.6 }}
    className="mt-16 flow-root sm:mt-24"
  >
    <div className="relative rounded-xl bg-black/5 shadow-xl ring-1 ring-black/20 backdrop-blur">
      <div className="absolute -top-px left-20 right-11 h-px bg-gradient-to-r from-violet-300/0 via-violet-300/70 to-violet-300/0" />
      <div className="absolute -bottom-px left-11 right-20 h-px bg-gradient-to-r from-violet-400/0 via-violet-400/70 to-violet-400/0" />
      <Demo/>
    </div>
  </motion.div>
)}
      </div>
    </div>
  )
}